import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useCurrentWorkspaceMember } from '~/swr-hooks/members/useCurrentWorkspaceMember';

const MAX_DELETION_RECOVERY_WINDOW = 365;

export const useDeletionRecoveryWindow = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { currentWorkspaceMember } = useCurrentWorkspaceMember();

  return {
    /* The recovery window configured for the workspace based on their subscription plan */
    configuredRecoveryWindow: currentWorkspace?.deletionRecoveryWindow ?? 0,
    /* The derrived recovery window for the current user based on their role */
    recoveryWindow: currentWorkspaceMember?.isSysAdmin
      ? MAX_DELETION_RECOVERY_WINDOW
      : (currentWorkspace?.deletionRecoveryWindow ?? 0),
  };
};
